import React from 'react'
import PageLayout from './pagelayout';
import GetMaster from './getmaster';

const MasterPage = ({id, heading}) => {
    return (
        <PageLayout bgWhite fullWidth>
            <div className="container">
                <div className="flex-center">
                    <h1 className="header-underline f-600 m-b-20 m-t-20">{heading}</h1>
                </div>
                <div className="static-content">
                    <GetMaster id={id} />                
                </div>
            </div>
        </PageLayout>
    )
}

export default MasterPage
